/**
 * Parse a date string from the API as UTC.
 * Server stores timestamps in UTC but sometimes omits the 'Z' suffix.
 * This ensures JavaScript correctly interprets them as UTC.
 */
export function parseUTC(dateString) {
  if (!dateString) return null;
  const s = String(dateString);
  if (s.endsWith('Z') || s.includes('+') || s.includes('-', 10)) return new Date(s);
  return new Date(s + 'Z');
}

/**
 * Format a UTC date string to locale string in user's timezone.
 */
export function formatDate(dateString) {
  const d = parseUTC(dateString);
  return d ? d.toLocaleString() : '—';
}

/**
 * Format a UTC date string to short date (e.g. "Apr 23, 2026").
 */
export function formatShortDate(dateString) {
  const d = parseUTC(dateString);
  return d ? d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : '—';
}

/**
 * Format a UTC date string to time ago (e.g. "5m ago").
 */
export function formatTimeAgo(dateString) {
  const date = parseUTC(dateString);
  if (!date) return '—';
  const now = new Date();
  const diffInMs = now - date;
  const diffInMins = Math.floor(diffInMs / (1000 * 60));
  const diffInHours = Math.floor(diffInMs / (1000 * 60 * 60));
  const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));

  if (diffInMins < 1) return 'Just now';
  if (diffInMins < 60) return `${diffInMins}m ago`;
  if (diffInHours < 24) return `${diffInHours}h ago`;
  if (diffInDays < 7) return `${diffInDays}d ago`;
  return date.toLocaleDateString();
}
